import React, { useEffect, useState } from "react";
import { Notes } from "../../components/Notes/Notes";
import "./NotesContainer.scss";

import attach_svg from "../../common/icons/svg/attach.svg";
import voice_svg from "../../common/icons/svg/voice.svg";
import moment from "moment";
import { ADD_NOTE_OPTIONS, ADD_NOTE_SELECT, getDownloadChartOption, NOTES_TYPE, PAGE_PARENT, SIDEBAR_ICON, USER_ROLE } from "../../common/constant/common-constants";
import { getDoctorNotesOptions, getNotes, postNotes, trialNote, updateNote } from "../../helper/notes-helper";
import { connect } from "react-redux";
import { CLINICAL_SCORE, NOTES_CONSTANT } from "../../common/constant/page-constants";
import { StatefulEditor } from "../../components/StatefulEditor/StatefulEditor";
import { handleScrollToBottom } from "../../common/utils/CommonUtils";
import { NOTE_INPUT_TYPE } from "../../common/constant/notes-contants";
import InitialAssessmentNote from "../../components/InitialAssessmentNote/InitialAssessmentNote";
import { getDiagnosisNamesHelper } from "../../helper/patient-helper";

function NotesContainer(props) {

    const [notesData, setNotesData] = useState([]);
    const [notesType, setNotesType] = useState();
    const [activeNote, setActiveNote] = useState(notesData && notesData[0]);
    const [isAddNote, setIsAddNote] = useState(false);
    const [newNote, setNewNote] = useState(null);
    const [editActiveNote, setEditActiveNote] = useState(false);
    const [addNoteSelection, setAddNoteSelection] = useState("");
    const [addNoteSelectDialogActive, setAddNoteSelectDialogActive] = useState(false);
    const [templateInputObj, setTemplateInputObj] = useState({});
    const [selectTextInput, setSelectTextInput] = useState("");
    const [selectOptionsAvailable, setSelectOptionsAvailable] = useState([]);
    const [currectSelectBox, setCurrentSelectBox] = useState("");

    useEffect(() => {
        setNotesType(props.notesType);
    }, [props.notesType]);

    useEffect(() => {
        handleScrollToBottom(NOTES_CONSTANT.NOTES_DATA_ID)
    }, [notesData]);

    useEffect(() => {
        updateNotesData();

    }, []);


    useEffect(() => {
        console.log(templateInputObj)

    }, [templateInputObj])

    useEffect(() => {
        if (selectTextInput && selectTextInput.length) {
            let data = {
                name: selectTextInput.split('_')[0],
                semanticTag: selectTextInput.split('_')[1]
            }
            if (data.semanticTag === NOTE_INPUT_TYPE.DIAGNOSIS)
                data.classification = selectTextInput.split('_')[0];

            console.log("option call data", data);
            if (data.name && (data.name.length % 3)) {
                if (data.classification) {
                    getDiagnosisNamesHelper(data).then((res) => {
                        handleDiagSelectOptions(res.diagnosis)
                        console.log('res of diagnosis name', res);
                    }).catch((err) => {
                        console.log("error in helper", err);
                    })
                }
                else {
                    getDoctorNotesOptions(data).then((res) => {
                        console.log("options from dropdown api", res.data)
                        if (res.data.length) {
                            let tempSelectOptions = res.data.map((ele, count) => { return { name: ele.term, label: ele.term, id: `count-${selectTextInput.split('_')[0]}` } })
                            // console.log("tempSelectOptions", tempSelectOptions);
                            setSelectOptionsAvailable(tempSelectOptions);
                        }
                    }).catch((err) => {
                        console.log("err in select api", err)
                    })
                }
            } else if (selectTextInput.split('_')[0].length) {
                let timer1 = setTimeout(() => {
                    if (data.classification) {
                        getDiagnosisNamesHelper(data).then((res) => {
                            handleDiagSelectOptions(res.diagnosis)
                            console.log('res of diagnosis name', res);
                        }).catch((err) => {
                            console.log("error in helper", err);
                        })
                    } else {
                        getDoctorNotesOptions(data).then((res) => {
                            // console.log("options from dropdown api", res)
                            if (res.data.length) {
                                let tempSelectOptions = res.data.map((ele, count) => { return { name: ele.term, label: ele.term, id: count } })
                                // console.log("tempSelectOptions", tempSelectOptions);
                                setSelectOptionsAvailable(tempSelectOptions);
                            }
                        }).catch((err) => {
                            console.log("error in helper", err);
                        })
                    }

                }, 2000);

                return () => {
                    clearTimeout(timer1);
                };
            }
        }
    }, [selectTextInput])

    useEffect(() => {
        setSelectTextInput("");
        setSelectOptionsAvailable([]);
    }, [currectSelectBox])

    const handleDiagSelectOptions = (optionsArr) => {
        let diagSelectOptions = optionsArr.length > 0 && optionsArr.map((ele) => ({ name: ele.classification, label: ele.classification }))
        // setDiagnosisNameOptions(diagSelectOptions);
        setSelectOptionsAvailable(diagSelectOptions);
    }

    console.log("active note, add note selection", activeNote, addNoteSelection);
    const updateNotesData = () => {
        let data = {
            bedId: props.bedId,
            patientSessionId: props.patientData.sessionId,
            type: props.notesType
        }

        getNotes(data).then((res) => {
            // setNotesData(notes);
            if (res.notes) {
                setNotesData(res.notes);
                setActiveNote(res.notes[0]);
                setAddNoteSelection("");
            }
        });
    }

    const postNotesData = (value) => {
        if (addNoteSelection === ADD_NOTE_OPTIONS.GENERAL_NOTE) {
            let data = {
                bedId: props.bedId,
                patientSessionId: props.patientData.sessionId,
                type: props.notesType,
                message: value,
                templateNoteType: ADD_NOTE_OPTIONS.GENERAL_NOTE
            }

            postNotes(data).then((res) => {
                updateNotesData();
            });
        } else if (addNoteSelection === ADD_NOTE_OPTIONS.INITIAL_ASSESSMENT) {
            let data = {
                bedId: props.bedId,
                patientSessionId: props.patientData.sessionId,
                type: props.notesType,
                message: "Initial Asssessment",
                templateNoteType: ADD_NOTE_OPTIONS.INITIAL_ASSESSMENT,
                noteData: templateInputObj
            }
            postNotes(data).then((res) => {
                console.log("res in post notes", res);
                updateNotesData();
            }).catch((err) => {
                console.log("err in note post", err);
            })
        }

    }

    const handleKeyDown = (event) => {
        const isEnterKey = (event.keyCode === 13);
        if (isEnterKey && !event.shiftKey) {
            let value = event && event.target && event.target.value;
            if (!value) return;
            postNotesData(value);
            event.target.value = "";
            return false;
        }
    }

    const handleNoteChange = (note) => {
        // console.log("changed note", note);
        setNewNote(note);
    }

    const handleNoteCancel = () => {
        setAddNoteSelection("");
        console.log("cancel was clicked");
        // setIsAddNote(false);
        updateNotesData();
    }

    const handleNoteSave = () => {

        // setIsAddNote(false);
        setAddNoteSelection("");
        postNotesData(newNote);
    }

    const handleEditNoteCancel = () => {
        setEditActiveNote(false)
        // setAddNoteSelection("");
    }

    const handleEditNoteSave = () => {
        let data = {
            noteId: activeNote.id,
            message: newNote,
            patientSessionId: props.patientData.sessionId,
        }
        updateNote(data).then((res) => {
            // console.log(res);
            updateNotesData();
            setEditActiveNote(false);
        }).catch((err) => {
            console.log("error in notes update API", err);
        })

    }

    const handleEditActiveNote = () => {
        setEditActiveNote(true);
    }

    const handleAddNoteClick = () => {
        setAddNoteSelectDialogActive(!addNoteSelectDialogActive);
    }

    const handleNoteTypeSelection = (option) => {
        setAddNoteSelection(option);
        setAddNoteSelectDialogActive(false);
        setActiveNote("");
        setTemplateInputObj({});
    }

    const handleTemplateInputChange = (childName, childType, value, parentName) => {
        console.log("name::", childName, "  childType:: ", childType, "  value::", value);
        // if (!value) return;

        if (childType === NOTE_INPUT_TYPE.RADIO) {
            setTemplateInputObj((prevState) => (
                {
                    ...prevState,
                    [parentName]: {
                        childSelected: childName,
                        details: "",
                        valType: childType
                    }
                }
            ))
        } else if (childType === NOTE_INPUT_TYPE.DETAILS) {
            setTemplateInputObj((prevState) => (
                {
                    ...prevState,
                    [parentName]: {
                        childSelected: childName,
                        details: value,
                        valType: NOTE_INPUT_TYPE.RADIO
                    }
                }
            ))
        } else if (childType === NOTE_INPUT_TYPE.SELECT) {
            setTemplateInputObj((prevState) => (
                {
                    ...prevState,
                    [childName]:
                    {
                        name: value && value.name,
                        label: value && value.label,
                        valType: childType
                    }
                }
            ))
        } else if (childType === NOTE_INPUT_TYPE.SELECT_DETAIL) {
            setTemplateInputObj((prevState) => (
                {
                    ...prevState,
                    [parentName]: {
                        childSelected: childName,
                        details: value.name,
                        valType: NOTE_INPUT_TYPE.RADIO
                    }
                }
            ))
        } else {
            setTemplateInputObj((prevState) => (
                {
                    ...prevState,
                    [childName]:
                    {
                        value: value,
                        valType: childType
                    }
                }
            ))
        }
    }
    const handleSelectInput = (text, semanticTag) => {
        console.log("input in select", text, semanticTag);
        if (semanticTag && semanticTag.length) {
            setSelectTextInput(text + '_' + semanticTag)
        } else {
            setSelectTextInput(text);
        }
    }
    const handleCurrentSelectBox = (ele) => {
        setCurrentSelectBox(ele);
    }

    return (
        <>
            {(props.parent === PAGE_PARENT.PATIENT_MODAL) && <div className="notes-container">
                <div className="notes-header-container">
                    <div className="notes-text">{notesType === NOTES_TYPE.NURSE ? 'Nurse Notes' : 'Doctor Notes'}</div>
                    <div className="notes-count-text">{`(${notesData && notesData.length})`}</div>
                </div>
                <div className="notes-data-container" id={NOTES_CONSTANT.NOTES_DATA_ID}>
                    {
                        notesData.map((note) => {
                            return (
                                <Notes
                                    key={note.id}
                                    data={note}
                                    notesType={props.notesType}
                                    type={NOTES_CONSTANT.MEDIUM} />)
                        })
                    }
                </div>
                <div className="input-container">
                    <div className="logo input-logo">
                        <img src={attach_svg} alt="attach svg" onClick={() => console.log("logo clicked !! ")} />
                        <img src={voice_svg} alt="voice svg" onClick={() => console.log("logo clicked !! ")} />
                    </div>
                    <textarea
                        className="notes-input"
                        placeholder="Type here"
                        rows={4}
                        onKeyDown={(e) => handleKeyDown(e)}></textarea>
                    {/* <input type="text" className="notes-input" placeholder="Type here" onKeyDown={(e) => handleKeyDown(e)} /> */}
                </div>
            </div>}
            {
                (props.parent === PAGE_PARENT.BED_DETAIL) && <div className="bed-details-notes-container">
                    <div className="notes-left-panel">
                        <div className="notes-header-container">
                            <div className="notes-text">{notesType === NOTES_TYPE.NURSE ? 'Nurse Notes' : 'Doctor Notes'}</div>
                            <div className="notes-count-text">{`(${notesData && notesData.length})`}</div>
                        </div>
                        <div className="notes-data-container">
                            {
                                notesData.map((note) => {
                                    return (
                                        <Notes
                                            key={note.id}
                                            data={note}
                                            notesType={props.notesType}
                                            type={NOTES_CONSTANT.SMALL}
                                            active={activeNote.id === note.id}
                                            showEdit={(props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE)}
                                            handleClick={(note) => {
                                                // setIsAddNote(false)
                                                setAddNoteSelection("");
                                                // console.log("note", note)
                                                setActiveNote(note)
                                            }}
                                        />);
                                })
                            }
                            {addNoteSelectDialogActive &&
                                <div className="add-note-select-dialog">
                                    {ADD_NOTE_SELECT.map((option) => <div className={`note-dialog-option ${addNoteSelection === option.name ? 'active-note-type' : ''}`} onClick={() => handleNoteTypeSelection(option.name)} key={option.id}>{option.label}</div>)}
                                </div>
                            }
                        </div>
                        {(props.userRole === props.notesType) && (props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE) && <div className="add-note-button-container">
                            <div className="add-note-button" onClick={handleAddNoteClick}>
                                Add a Note
                            </div>
                        </div>}
                    </div>
                    <div className="notes-right-panel">
                        {activeNote && (activeNote.templateNoteType !== ADD_NOTE_OPTIONS.INITIAL_ASSESSMENT) && !addNoteSelection && <Notes
                            key={activeNote.id}
                            data={activeNote}
                            notesType={props.notesType}
                            type={NOTES_CONSTANT.LARGE}
                            showEdit={(props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE)}
                            editActiveNote={editActiveNote}
                            handleEditNoteSave={handleEditNoteSave}
                            handleEditNoteCancel={handleEditNoteCancel}
                            handleEditActiveNote={handleEditActiveNote}
                            handleNoteChange={handleNoteChange}
                        />}
                        {activeNote && activeNote.templateNoteType === ADD_NOTE_OPTIONS.INITIAL_ASSESSMENT && !addNoteSelection &&
                            <InitialAssessmentNote
                                handleTemplateInputChange={handleTemplateInputChange}
                                addNoteActive={addNoteSelection}
                                patientData={props.patientData}
                                handleSelectInput={handleSelectInput}
                                handleCurrentSelectBox={handleCurrentSelectBox}
                                activeNote={activeNote}
                            // selectOptions={selectOptionsAvailable}

                            />
                        }
                        {/* <Notes
                                key={activeNote.id}
                                data={activeNote}
                                notesType={props.notesType}
                                type={NOTES_CONSTANT.LARGE}
                                showEdit={(props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE)}
                                editActiveNote={editActiveNote}
                                handleEditNoteSave={handleEditNoteSave}
                                handleEditNoteCancel={handleEditNoteCancel}
                                handleEditActiveNote={handleEditActiveNote}
                                handleNoteChange={handleNoteChange}
                            /> */}

                        {addNoteSelection === ADD_NOTE_OPTIONS.GENERAL_NOTE &&
                            <div className="add-note-container">
                                <div className="add-note-header">
                                    <div className="add-note-text">
                                        New Note
                                    </div>
                                    <div className="add-note-cta-container">
                                        <div
                                            className="add-note-cta cancel"
                                            onClick={() => handleNoteCancel()}>Cancel</div>
                                        <div
                                            className="add-note-cta save"
                                            onClick={() => handleNoteSave()}>Save</div>
                                    </div>
                                </div>
                                <div className="editor-container">
                                    <StatefulEditor onChange={(data) => handleNoteChange(data)} />
                                </div>
                            </div>
                        }
                        {addNoteSelection === ADD_NOTE_OPTIONS.INITIAL_ASSESSMENT &&
                            <InitialAssessmentNote
                                handleTemplateInputChange={handleTemplateInputChange}
                                addNoteActive={addNoteSelection}
                                templateInputObj={templateInputObj}
                                handleNoteCancel={handleNoteCancel}
                                handleNoteSave={handleNoteSave}
                                patientData={props.patientData}
                                handleSelectInput={handleSelectInput}
                                handleCurrentSelectBox={handleCurrentSelectBox}
                                selectOptionsAvailable={selectOptionsAvailable}
                            />
                        }
                    </div>
                </div>
            }
        </>
    );
}

const mapStateToProps = (state, ownProps) => {
    let patientData = state.patientDataReducer.patientData
        && state.patientDataReducer.patientData[ownProps.bedId]
    return {
        config: state.configReducer.config,
        userRole: state.userDataReducer.userRole,
        activeSidebarIcon: state.configReducer.config.activeSidebarIcon,
        patientData: patientData
    };
};

export default connect(mapStateToProps, null)(NotesContainer);